import { render, staticRenderFns } from "./NbTextInput.vue?vue&type=template&id=3c0b6c58&scoped=true&"
import script from "./NbTextInput.vue?vue&type=script&lang=js&"
export * from "./NbTextInput.vue?vue&type=script&lang=js&"
import style0 from "./NbTextInput.vue?vue&type=style&index=0&id=3c0b6c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b6c58",
  null
  
)

export default component.exports